require('./bootstrap');
require('./version');

$(function () {

    /**
     * Used to fix problem of `select2` plugin initialization problem with hidden elements.
     *
     * @type {*[]}
     */
    let readyContainers = [];

    const MERCHANT_TYPE = {
        PLATON: 1,
        PROFITGID: 2,
    };

    const ACQUIRER_TYPE = {
        LIQPAY: 1,
        AVAL: 2,
        ALFA: 3,
        MONO: 4,
        MONO_PP: 5,
        LEOBANK: 6,
        KUNA: 7,
        OSCHAD: 8,
        LEOGAMING: 9,
        BILLLINE: 10,
        PRIVAT_PP: 11,
        VOSTOK: 12,
        TASKOMBANK: 13,
        A2A_PROFITGID: 14,
        ABANK_PP: 15,
    };

    const SOURCE_TRANSACTION_TYPES = {
        IA: 1,
        DEBIT: 2,
        CREDIT: 3,
        IA_AND_DEBIT: 4,
    };

    const TRANSACTION_SPLIT_TYPES = {
        STANDARD: 1,
        GRADUAL: 2,
        AGENT: 3,
    };

    const A2A_COMMISSION_TYPES = {
        DEFAULT: 1,
        RECIPIENT: 2,
        SENDER: 3,
    };

    const FINANCE_SETTLEMENT_TYPE = {
        BANK: 1,
        BILLING: 2,
    };

    const MERCHANT_REPORT_TYPES = {
        STANDARD: 1,
        UNMATCHED_BILLING: 2,
    };

    const objectGetKeyByValue = function(object, value) {
        return Object.keys(object).find(key => object[key] === value).toLowerCase();
    };

    const select2AjaxConfigList = {
        clients: {
            url: '/filter-api/clients',
            data: function (params) {
                return  {
                    search: params.term
                }
            },
            processResults: function (data) {
                return {
                    results: data.map(row => ({id: row.id, text: row.name}))
                }
            }
        },
        merchants: {
            url: '/filter-api/merchant',
            data: function (params) {
                return  {
                    search: params.term
                }
            },
            processResults: function (data) {
                return {
                    results: data.map(row => ({id: row.id, text: row.name}))
                }
            }
        },
        terminals: {
            url: '/filter-api/terminals',
            data: function (params) {
                return  {
                    search: params.term
                }
            },
            processResults: function (data) {
                return {
                    results: data.map(row => ({id: row.id, text: row.name}))
                }
            }
        }
    };

    // Initializes numeric inputs.
    $('input[type="text"].js-input-text-numeric').each(function () {
        const options = $(this).data('options') || {};

        const {
            defaultValue = '',
            maxIntDigits = 10,
            maxDecDigits = 2,
            maxValue = 9999999999.99,
            allowNegative = false,
            minValue,
        } = options;


        const minBound = typeof minValue === 'number'
            ? minValue
            : (allowNegative ? -maxValue : 0.01);

        $(this).on('input', function (e) {
            let raw = String(e.target.value ?? '').replace(/,/g, '.');

            let cleaned = maxDecDigits
                ? raw.replace(/[^0-9.\-]/g, '')
                : raw.replace(/[^0-9\-]/g, '');

            let sign = '';
            if (allowNegative && cleaned.startsWith('-')) {
                sign = '-';
            }
            cleaned = cleaned.replace(/-/g, '');

            const hasTrailingDot = cleaned.endsWith('.');
            if (cleaned === '.') {
                cleaned = '0.';
            } else if (cleaned.startsWith('.') && cleaned.length > 1) {
                cleaned = '0' + cleaned;
            }

            let parts = cleaned.split('.');
            if (parts.length > 2) {
                cleaned = parts[0] + '.' + parts.slice(1).join('');
                parts = cleaned.split('.');
            }

            let [intPart = '', decPart = ''] = parts;
            intPart = intPart.slice(0, maxIntDigits);
            decPart = decPart.slice(0, maxDecDigits);

            if (/^0[0-9]+$/.test(intPart) && decPart === '') {
                intPart = '0';
            }

            let body = hasTrailingDot && decPart === '' ? `${intPart}.` : (decPart !== '' ? `${intPart}.${decPart}` : intPart);
            let val = (allowNegative ? sign : '') + body;

            if (allowNegative) {
                if (val === '-' || val === '-0.') {
                    e.target.value = val;

                    return;
                }
                if (val === '-.') {
                    val = '-0.';
                }
            }

            const num = parseFloat(val);
            if (!isNaN(num)) {
                if (num > maxValue) {
                    const [maxInt, maxDec] = String(maxValue).split('.');
                    val = (allowNegative && num < 0 ? '-' : '') + maxInt + (maxDec ? '.' + maxDec : '');
                } else if (num < minBound) {
                    val = '';
                }
            } else {
                if (!(allowNegative && (val === '-' || val === '-0.'))) {
                    val = '';
                }
            }

            e.target.value = val === '' ? defaultValue : val;
        });
    });

    $('input[type="checkbox"].js-checkbox-toggle-all').on('change', function () {
        console.log('all');
        const toggle = $(this).data('checkbox-toggle');

        if (!toggle) {
            return;
        }

        $(`input[type="checkbox"].js-checkbox-toggle-single[data-checkbox-toggle="${toggle}"]`)
            .prop('checked', $(this).prop('checked'));
    });

    $('input[type="checkbox"].js-checkbox-toggle-single').on('change', function () {
        console.log('single');
        const toggle = $(this).data('checkbox-toggle');

        if (!toggle) {
            return;
        }

        const singleElements = $(`input[type="checkbox"].js-checkbox-toggle-single[data-checkbox-toggle="${toggle}"]`);
        const allChecked = singleElements.filter(':checked').length === singleElements.length;

        $(`input[type="checkbox"].js-checkbox-toggle-all[data-checkbox-toggle="${toggle}"]`)
            .prop('checked', allChecked);
    });

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    $.fn.select2.defaults.set("theme", "bootstrap4");
    $.fn.select2.defaults.set("width", "100%");
    const fnInitializeSimpleSelects = function ($groupOfElements) {
        $groupOfElements = $groupOfElements ?? $(document);
        $groupOfElements.find('select.js-simple-select2').not('select2-hidden-accessible').each(async function () {
            const options = {
                placeholder: $(this).data('placeholder'),
                allowClear: Boolean($(this).data('allow-clear')),
                closeOnSelect: !$(this).attr('multiple'),
                width: 'element',
                tags: Boolean($(this).data('tags')),
            };

            const ajaxConfigName = $(this).data('ajaxConfig');
            if (ajaxConfigName && select2AjaxConfigList.hasOwnProperty(ajaxConfigName)) {
                options.ajax = {...select2AjaxConfigList[ajaxConfigName]}
                options.minimumInputLength = 3;
            }

            $(this).select2(options);
        });
    }
    fnInitializeSimpleSelects();


    $('input.js-simple-datepicker').each(function () {
        let options = {
            format: "yyyy-mm-dd",
            todayHighlight: true,
            weekStart: 1,
            autoclose: true,
        };

        const elementOptionsAttr = $(this).attr('data-options');
        if (elementOptionsAttr) {
            const elementOptions = JSON.parse(elementOptionsAttr);
            options = {...options, ...elementOptions};
        }

        $(this).datepicker(options);
    });

    $('.js-datetime-picker').each(function () {
        $(this).datetimepicker({
            allowInputToggle: true,
            showClose: true,
            showClear: true,
            showTodayButton: true,
            format: "YYYY-MM-DD HH:mm:ss"
        });
    });

    const rgb2hex = (rgb) => `#${rgb.match(/^rgb\a?\((\d+),\s*(\d+),\s*(\d+)\)$/).slice(1).map(n => parseInt(n, 10).toString(16).padStart(2, '0')).join('')}`;

    $('form').submit(function () {
        $(this).find('input[type="checkbox"]').each(function (i, elem) {
            if ($(elem).prop('checked') == true) {
                $(elem).parents('form')
                    .find('input[type="hidden"][name="' + $(elem).prop('name') + '"]').prop('disabled', true);
            }
        });
    });

    /// merchant.index

    $('#report-source_transaction_types-input').on('change', function () {
        if ([
            SOURCE_TRANSACTION_TYPES.DEBIT,
            SOURCE_TRANSACTION_TYPES.IA_AND_DEBIT,
        ].includes(Number($(this).val()))
        ) {
            $('.js-debit-selected').css('display', '');
        } else {
            $('.js-debit-selected').css('display', 'none');
        }
    }).trigger('change');

    $('#report-type-input').on('change', function () {
        if ($(this).val() == 2) {
            $('.email-block').css('display', '');
        } else {
            $('.email-block').css('display', 'none');
        }
    }).trigger('change');
    $('.js-template-select2').select2({
        ajax: {
            url: '/reports/report/templates',
            dataType: 'json',
            data: function (params) {
                params.term = params.term ?? '';
                const merchant = $('#merchant_id').val();
                if (merchant) {
                    return {
                        search: params.term,
                        merchant_id: merchant
                    };
                }
                return {
                    search: params.term
                };
            },
            processResults: function (data) {
                return {
                    results: data
                };
            }
        }
    });

    const $modalCopyTemplate = $('.js-modal-copy-template');
    if ($modalCopyTemplate.length > 0) {
        const $inputTemplate = $('#merchants_template_to_copy'),
            $select2 = $('.js-merchants-copy-template-select2');
        $select2.select2({
            placeholder: $(this).data('placeholder'),
            allowClear: Boolean($(this).data('allow-clear')),
            closeOnSelect: !$(this).attr('multiple'),
            width: 'style',
            ajax: {
                url: '/merchants/copy',
                dataType: 'json',
                data: function (params) {
                    params.term = params.term ?? '';
                    return {
                        search: params.term,
                        id: $inputTemplate.val(),
                    }
                },

                processResults: function (data) {
                    return {
                        results: data
                    };
                }
            }
        });
        const fnModalCopyTemplateShow = function () {
            const $btn = $(this);
            $inputTemplate.val($btn.data('merchant'));
            $modalCopyTemplate.modal('show');
        };
        const fnModalCopyTemplateSubmit = function () {
            $.post('/merchants/copy', {
                id: $inputTemplate.val(),
                to: $select2.val(),
            }).done(function (result) {
                if (result.status == 'success') {
                    window.location.reload();
                }
            });
        };

        $(document).on('click', 'button.js-btn-link', fnModalCopyTemplateShow);
        $(document).on('click', 'button.js-template-btn-copy', fnModalCopyTemplateSubmit);
        $modalCopyTemplate.on('hidden.bs.modal', function () {
            $inputTemplate.val('');
            $select2.trigger('change');
        });

    }

    /// merchant.create-parent merchant.edit-parent

    const $parentChildMerchants = $('.js-parent-child-merchants');
    if ($parentChildMerchants.length > 0) {
        let nextParentChildMerchantIndex = Number($parentChildMerchants.data('next-index'));

        /**
         * Appends a new empty child merchant row, keyed by a row index not used by any other row yet.
         *
         * @param {jQuery.Event} evt Click event of the add button.
         * @returns {boolean}
         */
        const fnAddParentChildMerchantRow = function (evt) {
            evt.preventDefault();

            const $rowTemplate = $($('#parent_child_merchant_row')[0].content.cloneNode(true));
            $rowTemplate.find('select[data-name]').each(function (/** @type {number} */ idx, /** @type {HTMLSelectElement} */ elem) {
                $(elem).attr('name', $(elem).data('name') + '[' + nextParentChildMerchantIndex + ']');
            });
            nextParentChildMerchantIndex++;

            const $rows = $parentChildMerchants.find('.js-parent-child-merchant-rows');
            $rows.append($rowTemplate);
            fnInitializeSimpleSelects($rows.find('.js-parent-child-merchant-row').last());

            return false;
        };

        /**
         * Removes the child merchant row the delete button belongs to.
         *
         * @param {jQuery.Event} evt Click event of the delete button.
         * @returns {boolean}
         */
        const fnRemoveParentChildMerchantRow = function (evt) {
            evt.preventDefault();

            $(this).parents('.js-parent-child-merchant-row').remove();

            return false;
        };

        $(document).on('click', '.js-parent-child-merchant-add', fnAddParentChildMerchantRow);
        $(document).on('click', '.js-parent-child-merchant-delete', fnRemoveParentChildMerchantRow);
    }

    /// merchant.create merchant.update

    $('#form_merchant_create #acquirer_type, #form_merchant_update #acquirer_type').on('change', function () {
        let selectedKey = '';
        for (const [key, value] of Object.entries(ACQUIRER_TYPE)) {
            const selector = `.${key.toLowerCase()}_block`;
            $(selector).css('display', 'none');
            if (value == $(this).val()) {
                selectedKey = key.toLowerCase();
            }
        }
        $(`.${selectedKey}_block`).css('display', '');
    }).trigger('change');

    $('#is_auto_json').on('change', function () {
        $('.auto_json').css('display', $(this).is(':checked') ? '' : 'none');
    }).trigger('change');

    $('.js--merchant--generate-credentials--btn').on('click', function () {
        const $inputPassword = $('input#json_password');
        const $inputApiKey = $('input#api_key');
        $.getJSON('/merchants/generate-credentials')
            .done(function (response) {
                if ('status' in response) {
                    if (response.status === 'success') {
                        $inputApiKey.val(response.apiKey);
                        $inputPassword.val(response.password);
                    }
                }
            });
    });

    $('.js-btn-generate-password').on('click', function () {
        const $inputPassword = $('input#json_password');
        $.getJSON('/merchants/generate-credentials')
            .done(function (response) {
                if ('status' in response) {
                    if (response.status === 'success') {
                        $inputPassword.val(response.password);
                    }
                }
            });
    });

    $('.js--merchant--copy-credential--btn').on('click', function () {
        const credential = $(this).data('credential');
        console.log(credential);

        const $input = $('input#' + credential);
        const text = $input.val();

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text)
                .catch(err => {
                    console.error('Failed to copy text via clipboard API', err);
                });
        } else {
            $input.select();

            try {
                document.execCommand("copy");
            } catch (err) {
                console.error('Failed to copy text via execCommand', err);
            }
        }
    });

    const $merchantForm = $('.js--merchant-form');

    const $merchantBrandFeeRows = $('.merchant_fee_block');
    if ($merchantBrandFeeRows.length > 0) {
        const avaliableBrands = $merchantBrandFeeRows.data('brands');

        const fnUpdateAvailableBrandList = function () {
            let usedBrands = [];
            $merchantBrandFeeRows
                .find('.js-merchant-brand-fee-row')
                .each(function (index, element) {
                    usedBrands.push($(element).data('brand-id'));
                });

            return avaliableBrands.filter(function (cardBrand) {
                return !usedBrands.includes(Number(cardBrand.id));
            }).map(function (cardObj) {
                return {id: cardObj.id, text: cardObj.name};
            });
        }

        const fnUpdateBrandSelect = function () {
            const $select = $('.js-brands-list-select');
            if ($select.hasClass("select2-hidden-accessible")) {
                $select.select2('destroy');
                $select.find('option').remove();
            }
            $select.select2({
                placeholder: $(this).data('placeholder'),
                allowClear: Boolean($(this).data('allow-clear')),
                closeOnSelect: !$(this).attr('multiple'),
                width: 'element',
                data: fnUpdateAvailableBrandList()
            });
        }
        fnUpdateBrandSelect();

        const fnAddNewBrandRow = function (evt) {
            evt.preventDefault();

            const $select = $('.js-brands-list-select');
            const newBrandId = $select.val();
            if (newBrandId !== '') {
                fnRenderNewBrandRow(newBrandId);
                fnUpdateBrandSelect();
            } else {
                alert("No Brand selected");
            }

            return false;
        }

        const fnAddNewBrandBlock = function (evt) {
            evt.preventDefault();

            const btn = $(this),
                brandId = btn.parents('.js-merchant-brand-fee-row').data('brand-id'),
                currentCount = btn.parents('.js-merchant-brand-fee-row')
                    .find('.js-merchant-brand-fee-block').length;
            fnRenderNewBrandBlock(brandId, currentCount);

            return false;
        }

        const fnRemoveBrandRow = function (evt) {
            evt.preventDefault();

            const btn = $(this);
            if (confirm("Do you want to delete entire tariff?")) {
                btn.parents('.js-merchant-brand-fee-row').remove();
                fnUpdateBrandSelect();
            }

            return false
        }

        const fnRemoveBrandBlock = function (evt) {
            evt.preventDefault();

            const btn = $(this),
                $merchantFeeRow = btn.parents('.js-merchant-brand-fee-row'),
                brandId = $merchantFeeRow.data('brand-id');
            if (confirm('Do you want to delete this tariff?')) {
                btn.parents('.js-merchant-brand-fee-block').remove();
                if ($merchantFeeRow.find('.js-merchant-brand-fee-block').length > 0) {
                    for (let i = 0; i < $merchantFeeRow.find('.js-merchant-brand-fee-block').length; i++) {
                        fnUpdateBlockFields($($merchantFeeRow.find('.js-merchant-brand-fee-block')[i]), brandId, i);
                    }
                } else {
                    $merchantFeeRow.remove();
                    fnUpdateBrandSelect();
                }
            }

            return false;
        }

        const fnRenderNewBrandRow = function (brandId) {
            const $rowTemplate = $($('#merchant_brand_fee_row')[0].content.cloneNode(true));
            $rowTemplate.find('.js-merchant-brand-fee-row').attr('data-brand-id', brandId);
            $('.js-merchant-brand-fee-rows').append($rowTemplate);
            fnRenderNewBrandBlock(brandId, 0);
        }

        const fnRenderNewBrandBlock = function (brandId, index) {
            const $blockTemplate = $($('#merchant_brand_fee_block')[0].content.cloneNode(true));
            fnUpdateBlockFields($blockTemplate, brandId, index);
            $('.js-merchant-brand-fee-row[data-brand-id="' + brandId + '"]')
                .find('.js-merchant-brand-fee-blocks')
                .append($blockTemplate);
        }

        const fnUpdateBlockFields = function ($block, brandId, index) {
            $block.find('span.brand-name').text(avaliableBrands.find(function (element) {
                return element.id == brandId;
            }).name);
            $block.find('input[type="hidden"][data-name="brandId"]').val(brandId);
            $block.find('input[data-name]').each(function (idx, elem) {
                $(elem).attr("name", "brandFees[" + brandId + "][" + index + "][" + $(elem).data("name") + "]");
                $(elem).attr("id", $(elem).attr("id") + index);
            });
            $block.find('[for]').each(function (idx, elem) {
                $(elem).attr("for", $(elem).attr("for") + index);
            });
        }

        $(document).on('click', '.js-merchant-brand-fee-block-add-btn', fnAddNewBrandBlock);
        $(document).on('click', '.js-merchant-brand-fee-row-add-btn', fnAddNewBrandRow);
        $(document).on('click', '.js-merchant-brand-fee-block-delete-btn', fnRemoveBrandBlock);
        $(document).on('click', '.js-merchant-brand-fee-row-delete-btn', fnRemoveBrandRow);
        $('[name="isHasCustomFee"]').on('change', function () {
            if ($(this).prop('checked')) {
                $merchantBrandFeeRows.show();

                fnInitializeSimpleSelects($merchantForm.find('#nav-tabContent #nav-fee'));
            } else {
                $merchantBrandFeeRows.hide();
            }
        }).trigger('change');
    }
    const $merchantBankFeeRows = $('.merchant_bank_fee_block');
    if ($merchantBankFeeRows.length > 0) {
        const $terminalSelect = $merchantForm.find('select#terminal_ids');
        readyContainers.push($merchantForm);

        const avaliableBankBrands = $merchantBankFeeRows.data('brands');

        const fnUpdateAvailableBankBrandList = function () {
            let usedBankBrands = [];
            $merchantBankFeeRows
                .find('.js-merchant-bank-fee-row')
                .each(function (index, element) {
                    usedBankBrands.push($(element).data('brand-id'));
                });

            return avaliableBankBrands.filter(function (cardBrand) {
                return !usedBankBrands.includes(Number(cardBrand.id));
            }).map(function (cardObj) {
                return {id: cardObj.id, text: cardObj.name};
            });
        }

        const fnUpdateBankBrandSelect = function () {
            const $select = $('.js-bank-brands-list-select');
            if ($select.hasClass("select2-hidden-accessible")) {
                $select.select2('destroy');
                $select.find('option').remove();
            }
            $select.select2({
                placeholder: $(this).data('placeholder'),
                allowClear: Boolean($(this).data('allow-clear')),
                closeOnSelect: !$(this).attr('multiple'),
                width: 'element',
                data: fnUpdateAvailableBankBrandList()
            });
        }
        fnUpdateBankBrandSelect();

        const fnAddNewBankBrandRow = function (evt) {
            evt.preventDefault();

            const $select = $('.js-bank-brands-list-select');
            const newBrandId = $select.val();
            if (newBrandId !== '') {
                fnRenderNewBankBrandRow(newBrandId);
                fnUpdateBankBrandSelect();
            } else {
                alert("No Brand selected");
            }

            return false;
        }

        const fnAddNewBankBrandBlock = function (evt) {
            evt.preventDefault();

            const btn = $(this),
                brandId = btn.parents('.js-merchant-bank-fee-row').data('brand-id'),
                currentCount = btn.parents('.js-merchant-bank-fee-row')
                    .find('.js-merchant-bank-fee-block').length;
            fnRenderNewBankBrandBlock(brandId, currentCount);

            return false;
        }

        const fnRemoveBankBrandRow = function (evt) {
            evt.preventDefault();

            const btn = $(this);
            if (confirm("Do you want to delete entire tariff?")) {
                btn.parents('.js-merchant-bank-fee-row').remove();
                fnUpdateBankBrandSelect();
            }

            return false
        }

        const fnRemoveBankBrandBlock = function (evt) {
            evt.preventDefault();

            const btn = $(this),
                $merchantFeeRow = btn.parents('.js-merchant-bank-fee-row'),
                brandId = $merchantFeeRow.data('brand-id');
            if (confirm('Do you want to delete this tariff?')) {
                btn.parents('.js-merchant-bank-fee-block').remove();
                if ($merchantFeeRow.find('.js-merchant-bank-fee-block').length > 0) {
                    for (let i = 0; i < $merchantFeeRow.find('.js-merchant-bank-fee-block').length; i++) {
                        fnUpdateBankBlockFields($($merchantFeeRow.find('.js-merchant-bank-fee-block')[i]), brandId, i);
                    }
                } else {
                    $merchantFeeRow.remove();
                    fnUpdateBankBrandSelect();
                }
            }

            return false;
        }

        const fnRenderNewBankBrandRow = function (brandId) {
            const $rowTemplate = $($('#merchant_bank_fee_row')[0].content.cloneNode(true));
            $rowTemplate.find('.js-merchant-bank-fee-row').attr('data-brand-id', brandId);
            $('.js-merchant-bank-fee-rows').append($rowTemplate);
            fnRenderNewBankBrandBlock(brandId, 0);
        }

        const fnRenderNewBankBrandBlock = function (brandId, index) {
            const $blockTemplate = $($('#merchant_bank_fee_block')[0].content.cloneNode(true));
            fnUpdateBankBlockFields($blockTemplate, brandId, index);
            $('.js-merchant-bank-fee-row[data-brand-id="' + brandId + '"]')
                .find('.js-merchant-bank-fee-blocks')
                .append($blockTemplate);
        }

        const fnUpdateBankBlockFields = function ($block, brandId, index) {
            $block.find('span.brand-name').text(avaliableBankBrands.find(function (element) {
                return element.id == brandId;
            }).name);
            $block.find('input[type="hidden"][data-name="brandId"]').val(brandId);
            $block.find('input[data-name]').each(function (idx, elem) {
                $(elem).attr("name", "bankFees[" + brandId + "][" + index + "][" + $(elem).data("name") + "]");
                $(elem).attr("id", $(elem).attr("id") + index);
            });
            $block.find('[for]').each(function (idx, elem) {
                $(elem).attr("for", $(elem).attr("for") + index);
            });
        }

        const amlBlockHandle = function () {
            const acquirerTypeId = +$('select[name="acquirerType"]').val();
            const splitTypeId = +$('select[name="splitTypeId"]').val();

            console.log(acquirerTypeId, splitTypeId);

            if (
                acquirerTypeId === ACQUIRER_TYPE.A2A_PROFITGID ||
                splitTypeId === TRANSACTION_SPLIT_TYPES.GRADUAL
            ) {
                $merchantForm.attr('data-state--aml-contract-kind', 'multi');
            } else {
                $merchantForm.attr('data-state--aml-contract-kind', 'single');
            }
        }

        $(document).on('click', '.js-merchant-bank-fee-block-add-btn', fnAddNewBankBrandBlock);
        $(document).on('click', '.js-merchant-bank-fee-row-add-btn', fnAddNewBankBrandRow);
        $(document).on('click', '.js-merchant-bank-fee-block-delete-btn', fnRemoveBankBrandBlock);
        $(document).on('click', '.js-merchant-bank-fee-row-delete-btn', fnRemoveBankBrandRow);
        $('[name="isHasCustomBankFee"]').on('change', function () {
            if ($(this).prop('checked')) {
                $merchantBankFeeRows.show();

                fnInitializeSimpleSelects($merchantForm.find('#nav-tabContent #nav-fee'));
            } else {
                $merchantBankFeeRows.hide();
            }
        }).trigger('change');

        $('select[name="merchantType"]').on('change', function () {
            const merchantTypeId = +$(this).val();
            if (merchantTypeId) {
                $merchantForm.attr('data-state--merchant-type', objectGetKeyByValue(MERCHANT_TYPE, merchantTypeId));
            } else {
                $merchantForm.attr('data-state--merchant-type', 'none');
            }

        }).trigger('change');

        $('select[name="acquirerType"]').on('change', function (event, specific) {
            const acquirerTypeId = +$(this).val();
            if (acquirerTypeId) {
                $merchantForm.attr('data-state--acquirer-type', objectGetKeyByValue(ACQUIRER_TYPE, acquirerTypeId));
            } else {
                $merchantForm.attr('data-state--acquirer-type', 'none');
            }

            if (!specific || specific['isInit'] !== true) {
                $terminalSelect.val(null).trigger('change');
                const acquirerTerminalSupport = $terminalSelect.data('acquirer-support');
                const $terminalRow = $terminalSelect.closest('.js--terminal--row');
                if (acquirerTypeId && acquirerTerminalSupport.includes(acquirerTypeId)) {
                    $terminalRow.show();
                } else {
                    $terminalRow.hide();
                }
            }

            amlBlockHandle();
        }).trigger('change', {isInit: true});

        $('select[name="splitTypeId"]').on('change', function () {
            const splitTypeId = +$(this).val();
            if (splitTypeId) {
                $merchantForm.attr('data-state--split-type', objectGetKeyByValue(TRANSACTION_SPLIT_TYPES, splitTypeId));
            } else {
                $merchantForm.attr('data-state--split-type', 'none');
            }


            if (splitTypeId === TRANSACTION_SPLIT_TYPES.GRADUAL) {
                $('select[name="a2aCommissionId"]').prop('disabled', false);
                $('.js-split-type-gradual-block').show();
            } else {
                $('select[name="a2aCommissionId"]').prop('disabled', true);
                $('.js-split-type-gradual-block').hide();
            }

            if (splitTypeId === TRANSACTION_SPLIT_TYPES.AGENT) {
                $('.js--split-type--agent--required').prop('required', true);
            } else {
                $('.js--split-type--agent--required').prop('required', false);
            }

            amlBlockHandle();
        }).trigger('change');

        $('select[name="a2aCommissionId"]').on('change', function () {
            const a2aCommissionId = +$(this).val();

            if (!a2aCommissionId || a2aCommissionId === A2A_COMMISSION_TYPES.DEFAULT) {
                $('.js-a2a-commission-rules-block').hide();
            } else {
                $('.js-a2a-commission-rules-block').show();
            }
        }).trigger('change');

        $('select[name="financeSettlementId"]').on('change', function () {
            const financeSettlementId = +$(this).val();
            $merchantForm.attr(
                'data-state--finance-settlement-type',
                objectGetKeyByValue(FINANCE_SETTLEMENT_TYPE, financeSettlementId)
            );
        }).trigger('change');

        $('select[name="idReportType"]').on('change', function () {
            const idReportType = +$(this).val();
            if (idReportType) {
                $merchantForm.attr(
                    'data-state--report-type',
                    objectGetKeyByValue(MERCHANT_REPORT_TYPES, idReportType)
                );
            } else {
                $merchantForm.attr('data-state--report-type', 'none');
            }
        }).trigger('change');

        $terminalSelect.select2({
            ajax: {
                url: '/filter-api/terminals',
                data: function (params) {
                    return  {
                        acquirer: $('select[name="acquirerType"]').val(),
                        search: params.term
                    }
                },
                processResults: function (data) {
                    if (!$('select[name="acquirerType"]').val()) {
                        return {
                            results: []
                        }
                    }

                    return {
                        results: data.map(row => ({id: row.id, text: row.name}))
                    }
                }
            },
            closeOnSelect: false,
            minimumInputLength: 3,
            width: '100%',
        })

        $merchantForm.find('a[data-toggle="tab"]').on('shown.bs.tab', function (event) {
            const targetTab = $(event.target).data('target');
            fnInitializeSimpleSelects($merchantForm.find(`#nav-tabContent ${targetTab}`));

            if (targetTab === '#nav-general') {
                document.dispatchEvent(new CustomEvent('MerchantForm_generalTabShown'));
            }
        })
    }

    let $ppBlock = $('.pp_block'),
        $ppRows = $('.pp_block_rows');
    if ($ppBlock.length > 0) {
        const fnAddPp = function (evt) {
            evt.preventDefault();
            if ($('.pp_block_rows input[data-name="commission"]').filter(function () {
                return !this.value
            }).length === 0) {
                const ppTopIndex = $ppRows.find('div.pp-row').length;
                let $template = $($("#pp_profile_row")[0].content.cloneNode(true));
                $template.find('span.text-lg-right').text(ppTopIndex + 1);
                $template.find('[data-name]').each(function (index, elem) {
                    $(elem).attr("name", "ppCommissions[" + ppTopIndex + "][" + $(elem).data("name") + "]");
                });
                $template.find('input[data-name="parts"]').val(ppTopIndex + 1);
                $ppRows.append($template);
                $ppRows.find('.js-pp-delete-btn').hide();
                $ppRows.find('.js-pp-delete-btn').last().show();
            }
            return true;
        };

        const fnRemovePp = function (evt) {
            evt.preventDefault();
            const $btn = $(this),
                $row = $btn.parents('div.pp-row');
            if (($row.find('input[data-name="commission"]').val() !== ''
                    && confirm("Do you want to remove commission for this part?"))
                || $row.find('input[data-name="commission"]').val() === '') {
                $row.remove();
                fnRefreshCommissions();
                $ppRows.find('.js-pp-delete-btn').last().show();
            }
            return true;
        };

        const fnRefreshCommissions = function () {
            $ppRows.find('div.pp-row').each(function (idx, row) {
                const $row = $(row);
                $row.find('span.text-lg-right').text(idx + 1);
                $row.find('[data-name]').each(function (index, elem) {
                    $(elem).attr("name", "ppCommissions[" + idx + "][" + $(elem).data("name") + "]");
                });
                $row.find('input[data-name="parts"]').val(idx + 1);
            });
        }

        $(document).on('click', 'button.js-pp-add-btn', fnAddPp);
        $(document).on('click', 'button.js-pp-delete-btn', fnRemovePp);

        $ppRows.find('.js-pp-delete-btn').hide();
        $ppRows.find('.js-pp-delete-btn').last().show();
    }

    let emailTopIndex = $('.emails_block_rows .js-email-row').length + 1,
        $emailRows = $('.emails_block_rows');
    if ($emailRows.length > 0) {
        const fnAddEmail = function (evt) {
            evt.preventDefault();
            const $input = $('#email');
            if ($('.emails_block_rows .js-email-address input').filter(function () {
                return $(this).val().trim() == $input.val().trim();
            }).length !== 0) {
                return 0;
            }
            if ($('.emails_block_rows .js-email-row').length >= 15) {
                return 0;
            }
            let $item = $(`
                <div class="row form-group js-email-row">
                   <div class="col-sm-11 js-email-address">
                       <input name="emails[${emailTopIndex}]" id="emails_${emailTopIndex}" type="hidden" value="${$input.val()}" />
                       <span class="form-control">${$input.val()}</span>
                   </div>
                   <div class="col-sm-1 pull-right">
                       <span class="btn btn-danger js-email-delete fa fa-remove"></span>
                   </div>
                </div>
                `);
            $emailRows.append($item);
            $input.val('');
            emailTopIndex++;
            return 0;
        };
        const fnRemoveEmail = function (evt) {
            evt.preventDefault();
            $(this).parents(".js-email-row").remove();
        };
        $(document).on('click', 'button.js-email-add', fnAddEmail);
        $(document).on('click', 'span.js-email-delete', fnRemoveEmail);
    }

    $('.js-select2-main-client-id').select2({
        placeholder: $(this).data('placeholder'),
        allowClear: Boolean($(this).data('allow-clear')),
        closeOnSelect: !$(this).attr('multiple'),
        tags: false,
        createTag: function (params) {
            let term = $.trim(params.term),
                id = term.split('/([0-9]+)\-(.+)/')[0];
            if (term == '' || !id) {
                return null;
            }
            return {
                id: id,
                text: term,
            }
        },
        insertTag: function (data, tag) {
            data.push(tag);
        }
    });

    $('.js-select2-additional-client-ids').select2({
        placeholder: $(this).data('placeholder'),
        allowClear: Boolean($(this).data('allow-clear')),
        closeOnSelect: !$(this).attr('multiple'),
        tags: false,
        createTag: function (params) {
            let term = $.trim(params.term),
                id = term.split('/([0-9]+)\-(.+)/')[0];
            if (term == '' || !id) {
                return null;
            }
            return {
                id: id,
                text: term,
            }
        },
        insertTag: function (data, tag) {
            data.push(tag);
        }
    });

    let $pulledSelect = $('select#pulled_report_type');
    if ($pulledSelect.length > 0) {
        $('input#is_pulled').on('change', function () {
            if ($(this).is(':checked')) {
                $pulledSelect.next(".select2-container").show();
            } else {
                $pulledSelect.next(".select2-container").hide();
            }
        }).trigger('change');
    }

    /// templates.index

    const $templateDetailsModal = $('.modal.js-modal-details');
    if ($templateDetailsModal.length > 0) {
        const fnTemplatesDetailsShow = function (evt) {
            evt.preventDefault();
            const btn = $(this);
            $.get(btn.data('url')).done(function (resp) {
                if ('status' in resp && resp.status == 'success') {
                    $templateDetailsModal.find('.js-details-id').text(resp.result.id);
                    $templateDetailsModal.find('.js-details-name').text(resp.result.name);
                    $templateDetailsModal.find('.js-details-report-type').text(resp.result.reportType);
                    $templateDetailsModal.find('.js-details-acquirer-type').text(resp.result.acquirerType);
                    $templateDetailsModal.find('.js-details-extension').text(resp.result.extension);
                    resp.result.merchants = resp.result.merchants || [];
                    if ('merchants' in resp.result && resp.result.merchants.length > 0) {
                        for (let i = 0; i < resp.result.merchants.length; i++) {
                            $templateDetailsModal.find('.js-details-merchants').append(`
                                <tr>
                                    <td class="col-sm-2">${resp.result.merchants[i].id}</td>
                                    <td class="col-sm-10">${resp.result.merchants[i].name}</td>
                                </tr>
                            `);
                        }
                    }
                    resp.result.deletable = resp.result.deletable || 0;
                    if (resp.result.deletable == 0) {
                        $templateDetailsModal.find('button.js-details-btn-delete').css('display', 'none');
                    } else {
                        $templateDetailsModal.find('button.js-details-btn-delete').css('display', '');
                    }
                    $templateDetailsModal.modal('show');
                }
            });
        };
        const fnTemplateDetailsClear = function () {
            $templateDetailsModal.find('.js-details-id').text('');
            $templateDetailsModal.find('.js-details-name').text('');
            $templateDetailsModal.find('.js-details-report-type').text('');
            $templateDetailsModal.find('.js-details-acquirer-type').text('');
            $templateDetailsModal.find('.js-details-extension').text('');
            $templateDetailsModal.find('.js-details-merchants').html(null);
        };
        const fnTemplateDetailsDelete = function (evt) {
            evt.preventDefault();
            if (confirm('Do you want to remove this template?')) {
                $.ajax({
                    url: `/templates/${$templateDetailsModal.find('.js-details-id').text()}`,
                    type: 'DELETE',
                    success: function (result) {
                        if (result.status == 'success') {
                            window.location.reload();
                        } else {
                            alert("Template has reports or merchants linked to it!");
                        }
                    }
                });
            }
        };

        $(document).on('click', 'button.js-template-show', fnTemplatesDetailsShow);
        $(document).on('click', 'button.js-details-btn-delete', fnTemplateDetailsDelete);
        $templateDetailsModal.on('hidden.bs.modal', fnTemplateDetailsClear);
    }


    ///  templates.create  templates.edit
    let templateFieldConfigEditor = null;
    const $fieldListEditor = $('#field_list_editor');
    if ($fieldListEditor.length > 0) {
        templateFieldConfigEditor = {
            columns: [],
            availableColumns: [],
            $listElement: $fieldListEditor,
            $configField: $('#config'),
            $btnAddColumn: $('#btn_add'),
            $acquirerTypeSelect: $('select[name="acquirerType"]'),
            $reportTypeSelect: $('select[name="reportType"]'),
            $reportSubTypeSelect: $('select[name="reportSubType"]'),
            $form: $fieldListEditor.parents('form'),
            addColumn: function (field, title) {
                let column = {
                    field: field,
                    title: title
                };
                let i = this.columns.push(column) - 1;
                this.renderElement(column, i);
            },
            renderElement: function (column, i) {
                let textInputName = this.generateTextInputName(i),
                    selectInputName = this.generateSelectInputName(i),
                    selectOptions = this.buildSelectOptions(column.field),
                    template = `
<div class="row form-group" data-id="${i}">
    <div class="col-sm-5">
        <input class="form-control w-100" type="text" value="${column.title}" name="${textInputName}" maxlength="256"/>
    </div>
    <div class="col-sm-6">
        <select name="${selectInputName}" class="form-control w-100">
            ${selectOptions}
        </select>
    </div>
    <div class="col-sm-1">
        <a href="#" class="js-btn-remove btn btn-danger"><span class="fa fa-remove"></span></a>
    </div>
</div>`;
                this.$listElement.append(template);
                this.$listElement.find(`[data-id="${i}"] select`).select2({
                    tags: true,
                    width: 'element',
                    maximumInputLength: 256,
                    createTag: function (params) {
                        let term = $.trim(params.term);
                        if (term == '') {
                            return null;
                        }
                        return {
                            id: term,
                            text: term
                        }
                    }
                });
            },
            renderAllElements: function () {
                this.$listElement.each(function (elem) {
                    if ($(elem).hasClass("select2-hidden-accessible")) {
                        $(elem).select2('destroy');
                    }
                });
                this.$listElement.html('');
                for (let i = 0; i < this.columns.length; i++) {
                    this.renderElement(this.columns[i], i);
                }
            },
            generateTextInputName: function (i) {
                return `columns[name][${i}]`;
            },
            generateSelectInputName: function (i) {
                return `columns[field][${i}]`;
            },
            buildSelectOptions: function (field) {
                let options = '',
                    customField = true;
                for (let i = 0; i < this.availableColumns.length; i++) {
                    let selectedAttribute = '';
                    if (this.availableColumns[i].field == field) {
                        selectedAttribute = 'selected';
                        customField = false;
                    }
                    options += `
<option value="${this.availableColumns[i].field}" ${selectedAttribute}>
    ${this.availableColumns[i].title}
</option>
`;
                }
                if (customField) {
                    options += `
<option value="${field}" selected>
    ${field}
</option>
`;
                }

                return options;
            },
            loadAvailableOptions: function (id) {
                const self = this;

                const reportType = self.$reportTypeSelect.val();
                if (!reportType) {
                    return;
                }

                let acquirerType = self.$acquirerTypeSelect.val();
                if (reportType === '1' && !acquirerType) {
                    return;
                } else if (reportType === '2') {
                    acquirerType = null;
                }

                const settings = id ? {templateId: id} : {
                    reportType: reportType,
                    acquirerType: acquirerType,
                    reportSubType: self.$reportSubTypeSelect.val(),
                };
                $.get('/templates/fieldList', settings).done(function (response) {
                    if ('status' in response && response.status === 'success') {
                        self.availableColumns = [];
                        self.columns = [];
                        if ('availableColumns' in response && response.availableColumns.length > 0) {
                            for (let i = 0; i < response.availableColumns.length; i++) {
                                let column = {
                                    field: response.availableColumns[i].field,
                                    title: response.availableColumns[i].title,
                                };
                                templateFieldConfigEditor.availableColumns.push(column);
                            }
                        }
                        if ('defaultColumns' in response && response.defaultColumns.length > 0) {
                            for (let i = 0; i < response.defaultColumns.length; i++) {
                                let column = {
                                    field: response.defaultColumns[i].field,
                                    title: response.defaultColumns[i].title,
                                };
                                templateFieldConfigEditor.columns.push(column);
                            }
                        }
                        self.renderAllElements();
                        self.updateConfigField();
                    }
                });
            },
            updateColumnTitle: function (i, title) {
                this.columns[i].title = title;
                this.updateConfigField();
            },
            updateColumnField: function (i, field) {
                this.columns[i].field = field;
                this.updateConfigField();
            },
            updateColumn: function (i, title, field) {
                this.column[i].title = title;
                this.column[i].field = field;
                this.updateConfigField();
            },
            deleteColumn: function (i) {
                this.columns = this.columns.filter(function (value, idx) {
                    return idx !== i;
                });
                this.renderAllElements();
                this.updateConfigField();
            },
            updateConfigField: function () {
                this.$configField.val(JSON.stringify(this.columns));

                if (+this.$reportSubTypeSelect.val() === 5) {
                    this.$btnAddColumn.hide();
                    this.$listElement.find('input[type="text"]').attr('disabled', true);
                    this.$listElement.find('.js-btn-remove').hide();
                } else {
                    this.$btnAddColumn.show();
                    this.$listElement.find('input[type="text"]').attr('disabled', false);
                    this.$listElement.find('.js-btn-remove').show()
                }
            },
            selectChange: function () {
                const $select = $('select[name="reportType"]');
                if (parseInt($select.val()) === 1) {
                    $('.row.type-merchant').css('display', '')
                } else {
                    $('.row.type-merchant').css('display', 'none');
                }
            },
            init: function (id) {
                // event binding
                this.$listElement.on('click', '.js-btn-remove', function (e) {
                    e.stopPropagation();
                    let $btn = $(this);
                    templateFieldConfigEditor.deleteColumn($btn.parents('[data-id]').data('id'))
                }).on('change', 'select', function () {
                    let $input = $(this);
                    templateFieldConfigEditor.updateColumnField($input.parents('[data-id]').data('id'), $input.val());
                }).on('change', 'input[type="text"]', function () {
                    let $input = $(this);
                    templateFieldConfigEditor.updateColumnTitle($input.parents('[data-id]').data('id'), $input.val())
                });
                this.$btnAddColumn.on('click', function (e) {
                    e.stopPropagation();
                    templateFieldConfigEditor.addColumn('', '');
                });
                this.$acquirerTypeSelect.on('change', function () {
                    templateFieldConfigEditor.selectChange();
                    templateFieldConfigEditor.loadAvailableOptions();
                });
                this.$reportTypeSelect.on('change', function () {
                    templateFieldConfigEditor.selectChange();
                    templateFieldConfigEditor.loadAvailableOptions();
                });
                this.$reportSubTypeSelect.on('change', function () {
                    templateFieldConfigEditor.selectChange();
                    templateFieldConfigEditor.loadAvailableOptions();

                    if (+$(this).val() === 5) {
                        templateFieldConfigEditor.$btnAddColumn.hide();
                        templateFieldConfigEditor.$listElement.find('input[type="text"]').attr('disabled', true);
                        templateFieldConfigEditor.$listElement.find('.js-btn-remove').hide;
                    } else {
                        templateFieldConfigEditor.$btnAddColumn.show();
                        templateFieldConfigEditor.$listElement.find('input[type="text"]').attr('disabled', false);
                        templateFieldConfigEditor.$listElement.find('.js-btn-remove').show;
                    }
                });
                this.$form.on('submit', function (e) {
                    for (let i = 0; i < templateFieldConfigEditor.columns.length; i++) {
                        templateFieldConfigEditor.columns[i].title = templateFieldConfigEditor.columns[i].title.trim();
                        templateFieldConfigEditor.columns[i].field = templateFieldConfigEditor.columns[i].field.trim();
                        if (templateFieldConfigEditor.columns[i].title == '') {
                            templateFieldConfigEditor.$listElement.find(
                                `[name="${templateFieldConfigEditor.generateTextInputName(i)}"]`
                            ).parent('div').css('border', '2px solid red');
                            e.stopPropagation();
                            return false;
                        }
                        if (templateFieldConfigEditor.columns[i].field == '') {
                            templateFieldConfigEditor.$listElement.find(
                                `[name="${templateFieldConfigEditor.generateSelectInputName(i)}"]`
                            ).parent('div').css('border', '2px solid red');
                            e.stopPropagation();
                            return false;
                        }
                    }
                });
                this.$form.find('button.js--template--edit--reset--btn').on('click', function () {
                    templateFieldConfigEditor.loadAvailableOptions();
                });
                this.selectChange();
                // default fields load
                this.loadAvailableOptions(id);
            }
        }
        templateFieldConfigEditor.init($('input[name="id"]').val());
    }

    $('#report_sub_type').select2({
        placeholder: 'No Sub Type',
        allowClear: true,
        closeOnSelect: !$(this).attr('multiple'),
        width: 'element',
        ajax: {
            url: '/ajax/template/subtype',
            data: function () {
                return {
                    reportType: $('#report_type').val(),
                    acquirerType: $('#acquirer_type').val(),
                };
            },
            dataType: 'json',
            processResults: function (data) {
                return {
                    results: data
                };
            }
        }
    });

    /// failed

    const $failedTable = $('table.failed-transactions-table');
    if ($failedTable.length > 0) {
        const acquirerType = $failedTable.data('acquirer-type');
        const fnDeleteTransaction = function () {
            const $btn = $(this);
            if (confirm("Do you want to delete transaction?")) {
                const key = $btn.parents('tr[data-id]').data('id');

                $.post('/failed/remove-transaction', {id: key, acquirerType: acquirerType}).done(function (response) {
                    if ('status' in response) {
                        if (response.status === 'success') {
                            window.location.reload();
                        }
                    }
                });
            }
        }

        $('.js-delete-transaction').on('click', fnDeleteTransaction);

        const $matchTransactionModal = $('#match_transaction_modal'),
            $matchTransactionModalHeader = $matchTransactionModal.find('.modal-header'),
            $matchTransactionModalTable = $matchTransactionModal.find('tbody'),
            $matchTransactionModalSubmitBtn = $matchTransactionModal.find('.js-submit-transaction');

        const fnFailedMatchTransactionBtn = function (evt) {
            evt.preventDefault();
            const $btn = $(this),
                id = $btn.parents('tr[data-id]').data('id');
            $matchTransactionModalTable.html('');
            $.get('/failed/check', {id: id, acquirerType: acquirerType}).done(function (result) {
                if (result.status === 'success') {
                    result.orderIdString = result.orderIdString ?? '';
                    result.models = result.models ?? [];
                    $matchTransactionModalHeader.text('Order ID - ' + result.orderIdString);
                    const models = result.models;
                    for (let i = 0; i < models.length; i++) {
                        let checked = i == 0 ? 'checked' : '';
                        models[i].trDate = models[i].trDate ?? '';
                        $matchTransactionModalTable.append(`
                            <tr>
                                <td>${models[i].clientId}</td>
                                <td>${models[i].trDate}</td>
                                <td>${models[i].amount}</td>
                                <td>${models[i].type}</td>
                                <td>${models[i].status}</td>
                                <td><input type="radio" name="transactionId" 
                                    value="${models[i].id}" ${checked} /></td>
                            </tr>
                        `);
                    }
                    $matchTransactionModal.find('a.js-submit-transaction').data('id', id);
                    $matchTransactionModal.modal('show');
                }
            }).fail(function () {
                alert("No transaction data found");
            });
            return false;
        }
        const fnFailedMatchTransactionSubmit = function (evt) {
            evt.preventDefault();
            const
                $btn = $(this),
                id = $btn.data('id');
            $.post('/failed/check', {
                id: id,
                acquirerType: acquirerType,
                transactionId: $matchTransactionModalTable.find('input[name="transactionId"]:checked').val(),
            }).done(function (response) {
                if (response.status == 'success') {
                    $matchTransactionModal.modal('hide');
                    window.location.reload();
                } else {
                    alert("Can't match transactions");
                }
            }).fail(function () {
                alert("Can't match transactions");
            });
            return false;
        }
        $('.js-match-transaction').on('click', fnFailedMatchTransactionBtn);
        $matchTransactionModalSubmitBtn.on('click', fnFailedMatchTransactionSubmit);
        $matchTransactionModal.on('hidden.bs.modal', function () {
            $matchTransactionModalTable.html('');
        });

        const $acceptTransactionModal = $('#accept_transaction_modal'),
            $accepTransactionModalSubmitBtn = $acceptTransactionModal.find('.js-submit-accept-transaction');

        const fnFailedAcceptTransactionBtn = function (evt) {
            evt.preventDefault();
            const $btn = $(this),
                id = $btn.parents('tr[data-id]').data('id');

            const orderId = $(this).parents('tr[data-id]').data('orderId');

            $acceptTransactionModal.find('.js--form-group--order-id').toggle(!orderId);

            $acceptTransactionModal.find('#acceptFormId').val(id);
            $acceptTransactionModal.find('#acceptFormClientId').val('').trigger('change');
            $acceptTransactionModal.find('#acceptFormTransactionType').val('').trigger('change');
            $acceptTransactionModal.find('#acceptFormProcessingTransactionTypeId').val('').trigger('change');
            $acceptTransactionModal.find('#acceptFormProcessingTransactionDatetime').val('');
            $acceptTransactionModal.find('[name=orderId]').val('');
            $acceptTransactionModal.attr('tabindex', null);
            $acceptTransactionModal.find('.js-errors-block').hide();
            $acceptTransactionModal.modal('show');

            return false;
        }

        const fnFailedAcceptTransactionSubmit = function (evt) {
            evt.preventDefault();

            $acceptTransactionModal.find('.js-errors-block').hide();

            const $form = $acceptTransactionModal.find('form');
            const splitTypeId = +$form.find('select[name="splitTypeId"]').val();

            let postData = {
                id: +$form.find('input[name="id"]').val() || null,
                acquirerType: +$form.find('input[name="acquirerType"]').val() || null,
                clientId: +$form.find('select[name="clientId"]').val() || null,
                transactionType: +$form.find('select[name="transactionType"]').val() || null,
                processingTransactionTypeId: +$form.find('select[name="processingTransactionTypeId"]').val() || null,
                splitTypeId: splitTypeId || null,
                processingTransactionDatetime: $form.find('input[name="processingTransactionDatetime"]').val(),
                orderId: $form.find('input[name="orderId"]').val(),
            };

            if (splitTypeId) {
                const splitRules = validateGatherSplitRules($acceptTransactionModalSplitRulesBlock);

                if (splitRules === null) {
                    return false;
                }

                postData = { ...postData, splitRules};
            }

            $.post('/failed/accept', postData).done(function (response) {
                if (response.status === 'success') {
                    $acceptTransactionModal.modal('hide');
                    window.location.reload();
                } else {
                    const messages = response.messages;

                    alert("Can't accept transactions");
                    $acceptTransactionModal.find('.js-errors-block').empty();

                    if (messages) {
                        for (let field in messages) {
                            for (let i in messages[field]) {
                                const $divMessage = $('<div/>')
                                $divMessage.text(messages[field][i]);
                                $acceptTransactionModal.find('.js-errors-block').append($divMessage);
                            }
                        }
                        $acceptTransactionModal.find('.js-errors-block').show();
                    }
                }
            }).fail(function () {
                alert("Can't accept transactions");
            });
            return false;
        }

        $('.js-accept-transaction').on('click', fnFailedAcceptTransactionBtn);
        $accepTransactionModalSubmitBtn.on('click', fnFailedAcceptTransactionSubmit);
        $acceptTransactionModal.on('hide.bs.modal', function () {
            $acceptTransactionModal.attr('tabindex', '-1');
        });
        $acceptTransactionModal.find('select').each(function () {
            $(this).select2({
                placeholder: $(this).data('placeholder'),
                allowClear: Boolean($(this).data('allow-clear')),
                closeOnSelect: !$(this).attr('multiple'),
                width: 'style'
            });
        });

        $acceptTransactionModal.find('select[name="transactionType"]').on('change', function () {
            const $this = $(this);
            const transactionTypeId = +$this.val();

            $acceptTransactionModal.find('.js--split-type--block').toggleClass('d-none', transactionTypeId !== 1);
            if (transactionTypeId !== 1) {
                $acceptTransactionModal.find('select[name="splitTypeId"]').val(null).trigger('change');
            }
        });

        const $acceptTransactionModalSplitRulesBlock = $acceptTransactionModal.find('.js--split-rules--block');
        $acceptTransactionModal.find('select[name="splitTypeId"]').on('change', function () {
            const $this = $(this);
            const splitTypeId = +$this.val()

            if (!splitTypeId) {
                $acceptTransactionModalSplitRulesBlock.empty();
            } else {
                if (!$acceptTransactionModalSplitRulesBlock.children().length) {
                    acceptTransactionModalAddSplitRule();
                }
            }

            $acceptTransactionModalSplitRulesBlock.toggleClass('d-none', !splitTypeId);
        });

        $acceptTransactionModalSplitRulesBlock.on('click', '.js--split-rule--add--block--btn', function () {
            acceptTransactionModalAddSplitRule();
        });

        const acceptTransactionModalAddSplitRule = () => {
            const $template = $($acceptTransactionModal.find('#js--split-rule--block')[0].content.cloneNode(true));
            $acceptTransactionModalSplitRulesBlock.append($template);

            const $last = $acceptTransactionModalSplitRulesBlock.find('.js--split-rule--block').last();
            wireSplitInputs($last);

            const blocks = $acceptTransactionModalSplitRulesBlock.find('.js--split-rule--block');
            blocks.find('.js--split-rule--add--block').hide();
            blocks.last().find('.js--split-rule--add--block').show();
        }

        /* Start - Create match request */

        const $createMatchRequestModal = $('#create-match-request-modal');
        const $createMatchRequestForm = $createMatchRequestModal.find('#create-match-request-form');
        const $createMatchRequestSubmit = $createMatchRequestModal.find('.js-create-match-request-submit');
        $('.js-create-transaction-match-request').on('click', function (event) {
            event.preventDefault();
            const acquirerTransactionId = $(this).parents('tr[data-id]').data('id');
            const acquirerRrn = $(this).parents('tr[data-id]').data('rrn');
            const acquirerApproval = $(this).parents('tr[data-id]').data('approval');

            $createMatchRequestForm.find('[name=acquirerTransactionId]').val(acquirerTransactionId);
            $createMatchRequestForm.find('[name=requestTransactionType]').val('').trigger('change');
            $createMatchRequestForm.find('[name=requestRrn]').val('');
            $createMatchRequestForm.find('[name=requestApprovalCode]').val('');

            $createMatchRequestForm.find('.js--form-group--rrn').toggle(!acquirerRrn);
            $createMatchRequestForm.find('.js--form-group--approval').toggle(!acquirerApproval);

            $createMatchRequestModal.find('.js-errors-block').hide();

            $createMatchRequestModal.attr('tabindex', null);
            $createMatchRequestModal.modal('show');

            return false;
        });

        $createMatchRequestSubmit.on('click', function (event) {
            event.preventDefault();

            $createMatchRequestModal.find('.js-errors-block').hide();

            const $form = $createMatchRequestModal.find('form');
            const splitTypeId = +$form.find('select[name="splitTypeId"]').val();

            let postData = {
                acquirerTransactionId: +$form.find('input[name="acquirerTransactionId"]').val() || null,
                acquirerTypeId: +$form.find('input[name="acquirerTypeId"]').val() || null,
                requestTransactionType: +$form.find('select[name="requestTransactionType"]').val() || null,
                splitTypeId: splitTypeId || null,
                requestRrn: $form.find('input[name="requestRrn"]').val(),
                requestApprovalCode: $form.find('input[name="requestApprovalCode"]').val(),
            };

            if (splitTypeId) {
                const splitRules = validateGatherSplitRules($createMatchRequestModalSplitRulesBlock);

                if (splitRules === null) {
                    return false;
                }

                postData = { ...postData, splitRules};
            }

            $.post('/failed/create-match-request', postData)
                .done(function (response) {
                    if (response.success) {
                        $createMatchRequestModal.modal('hide');
                        window.location.reload();
                    } else {
                        const requestUuid = response.requestUuid;
                        const error = response.error;
                        const messages = response.messages;

                        let message = '';
                        if (requestUuid) {
                            message = `[${requestUuid}] `;
                        }
                        message += error;

                        alert(message);
                        $createMatchRequestModal.find('.js-errors-block').empty();

                        if (messages) {
                            for (let field in messages) {
                                for (let i in messages[field]) {
                                    const $divMessage = $('<div/>')
                                    $divMessage.text(messages[field][i]);
                                    $createMatchRequestModal.find('.js-errors-block').append($divMessage);
                                }
                            }
                            $createMatchRequestModal.find('.js-errors-block').show();
                        }
                    }
                })
                .fail(function () {
                    alert("Unexpected error.");
                });

            return false;
        });

        $createMatchRequestModal.on('hide.bs.modal', function () {
            $createMatchRequestModal.find('.js-errors-block').empty();
            $createMatchRequestModal.find('.js-errors-block').hide();
        });

        $createMatchRequestModal.find('select').each(function () {
            $(this).select2({
                placeholder: $(this).data('placeholder'),
                allowClear: Boolean($(this).data('allow-clear')),
                closeOnSelect: !$(this).attr('multiple'),
                width: 'style'
            });
        });

        $createMatchRequestModal.find('select[name="requestTransactionType"]').on('change', function () {
            const $this = $(this);
            const transactionTypeId = +$this.val();

            const isSplitTypeAvailable = transactionTypeId === 1 || transactionTypeId === 2;

            $createMatchRequestModal.find('.js--split-type--block').toggleClass('d-none', !isSplitTypeAvailable);
            if (!isSplitTypeAvailable) {
                $createMatchRequestModal.find('select[name="splitTypeId"]').val(null).trigger('change');
            }
        });

        const $createMatchRequestModalSplitRulesBlock = $createMatchRequestModal.find('.js--split-rules--block');
        $createMatchRequestModal.find('select[name="splitTypeId"]').on('change', function () {
            const $this = $(this);
            const splitTypeId = +$this.val()

            if (!splitTypeId) {
                $createMatchRequestModalSplitRulesBlock.empty();
            } else {
                if (!$createMatchRequestModalSplitRulesBlock.children().length) {
                    createMatchRequestModalAddSplitRule();
                }
            }

            $createMatchRequestModalSplitRulesBlock.toggleClass('d-none', !splitTypeId);
        });

        $createMatchRequestModalSplitRulesBlock.on('click', '.js--split-rule--add--block--btn', function () {
            createMatchRequestModalAddSplitRule();
        });

        const createMatchRequestModalAddSplitRule = () => {
            const $template = $($createMatchRequestModal.find('#js--split-rule--block')[0].content.cloneNode(true));
            $createMatchRequestModalSplitRulesBlock.append($template);

            const $last = $createMatchRequestModalSplitRulesBlock.find('.js--split-rule--block').last();
            wireSplitInputs($last);

            const blocks = $createMatchRequestModalSplitRulesBlock.find('.js--split-rule--block');
            blocks.find('.js--split-rule--add--block').hide();
            blocks.last().find('.js--split-rule--add--block').show();
        }

        /* End - Create match request */

        const wireSplitInputs = ($ctx) => {
            $ctx.find('input[name="subMerchantId"]')
                .on('input paste', function (e) {
                    $(this).removeClass('is-invalid');

                    let raw = e.type === 'paste'
                        ? (e.preventDefault(), (e.originalEvent.clipboardData || window.clipboardData).getData('text'))
                        : this.value;

                    raw = String(raw ?? '').trim();

                    if (/[0-9]/.test(raw)) {
                        this.value = raw
                            .replace(/\D+/g, '')
                            .replace(/^0+/, '')
                            .slice(0, 20);
                        return;
                    }

                    this.value = raw
                        .toUpperCase()
                        .replace(/[^P]/g, '')
                        .slice(0, 2);
                });

            $ctx.find('input[name="amount"]')
                .on('input paste', function (e) {
                    $(this).removeClass('is-invalid');

                    let v = e.type === 'paste'
                        ? (e.preventDefault(), (e.originalEvent.clipboardData || window.clipboardData).getData('text'))
                        : this.value;

                    v = String(v).replace(/,/g, '.').replace(/[^0-9.]/g, '');

                    const firstDot = v.indexOf('.');
                    if (firstDot !== -1) {
                        v = v.slice(0, firstDot + 1) + v.slice(firstDot + 1).replace(/\./g, '');
                    }

                    const hadDot = v.includes('.');
                    if (v.startsWith('.')) {
                        v = '0' + v;
                    }

                    let [int = '', frac = ''] = v.split('.');
                    int = int.replace(/^0+(?=\d)/, '');

                    if (int.length > 8) {
                        int = int.slice(0, 8);
                    }
                    if (frac) {
                        frac = frac.slice(0, 2);
                    }

                    this.value = frac
                        ? `${int || '0'}.${frac}`
                        : (hadDot ? `${int || '0'}.` : (int || '0'));
                });
        }

        const validateGatherSplitRules = ($ctx) => {
            const rules = [];
            const subMerchantIdsUsed = {};
            let hasError = false;


            $ctx.find('.js--split-rule--block').each(function() {
                const $block = $(this);

                const $subMerchantId = $block.find('input[name="subMerchantId"]');
                const subMerchantIdRaw = String($subMerchantId.val() ?? '').trim();
                const subMerchantIdUpper = subMerchantIdRaw.toUpperCase();

                const isPP = subMerchantIdUpper === 'PP';
                const isInt = /^[0-9]+$/.test(subMerchantIdRaw);

                if (!subMerchantIdRaw) {
                    hasError = true;
                    $subMerchantId.addClass('is-invalid');
                    $subMerchantId.siblings('.js--invalid-feedback').text("SubmerchantId can't be empty");
                } else if (!isPP && !isInt) {
                    hasError = true;
                    $subMerchantId.addClass('is-invalid');
                    $subMerchantId.siblings('.js--invalid-feedback').text('SubmerchantId must be integer or "PP"');
                } else {
                    const key = isPP ? 'PP' : subMerchantIdRaw;

                    if (subMerchantIdsUsed.hasOwnProperty(key)) {
                        hasError = true;
                        $subMerchantId.addClass('is-invalid');
                        $subMerchantId.siblings('.js--invalid-feedback').text("Duplicate SubmerchantId");
                    }
                    subMerchantIdsUsed[key] = true;
                }

                const $amount = $block.find('input[name="amount"]');
                const amount = $amount.val();
                if (amount === undefined || amount === null || !String(amount).length) {
                    hasError = true;
                    $amount.addClass('is-invalid');
                    $amount.siblings('.js--invalid-feedback').text("Submerchant amount can't be empty");
                }

                rules.push({
                    amount,
                    subMerchantId: isPP ? 'PP' : subMerchantIdRaw,
                });
            });

            if (hasError) {
                return null;
            } else {
                return rules;
            }
        }
    }


    /// reports.index

    const $reportsTable = $('#table_report');
    if ($reportsTable.length > 0) {

        let reportUrl = null;
        const fnReportsShowEmailPopup = function (evt) {
            evt.preventDefault();
            const btn = $(this);
            reportUrl = btn.data('url');
            $templateDetailsModal.modal('show');
        };

        const fnReportsSubmitReportToEmail = function (evt) {
            evt.preventDefault();
            $('.spinner-grow').show();
            $.post(reportUrl, {
                emails: [$('#email').val()]
            }).done(function (result) {
                if (result.status == 'success') {
                    window.location.reload();
                } else {
                    $('.alert-danger').show().delay(3000).fadeOut(1000);
                }
                $('.spinner-grow').hide();
            });
            reportUrl = null;
        };

        $(document).on('click', 'button.js-template-show', fnReportsShowEmailPopup);
        $(document).on('submit', '#send-report-to-email', fnReportsSubmitReportToEmail);
        $('.js-report-merchant-export').on('click', function () {
            const $form = $(this).closest('form');
            const formData = new FormData($form[0])

            const from = formData.get('createdAtFrom').toString(),
                to = formData.get('createdAtTo').toString();

            if (!from || !to) {
                alert('Select both dates.');
                return;
            }

            const fromObject = new Date(from),
                toObject = new Date(to);

            if (fromObject.getTime() > toObject.getTime()) {
                alert('`Created from` should be less or equal to `To`');
                return;
            }

            if ((toObject - fromObject) / 86_400_000 > 366) {
                alert('The selected report creation date range exceeds 1 year. Please reduce the range and try again.');
                return;
            }

            const formArray = $form.serializeArray();
            const filters = {};
            formArray.forEach(({ name, value }) => {
                if (name.endsWith('[]')) {
                    name = name.slice(0, -2);
                    if (!filters[name]) {
                        filters[name] = [];
                    }
                    filters[name].push(value);
                } else {
                    filters[name] = value || null;
                }
            });

            $.ajax({
                url: '/reports/export-processes/create',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({
                    id_export_process: 1,
                    filters: filters
                })
            }).done(function (response) {
                if (response.status === 'success' && response.message) {
                    exportProcess_successNotificationShow(response.message);
                } else {
                    alert(response.message ? response.message : "Error has occurred.");
                }
            }).fail(function () {
                alert("Error has occurred.");
            });
        });

        $('.js-report-parent-refresh-button').on('click', function () {
            const $modal = $('.js-report-parent-refresh-modal');
            $modal.modal('show');

            $modal.find('.js-confirm').on('click', function (event) {
                event.preventDefault();

                $.post('/reports/parent-refresh', $modal.find('form').serialize())
                    .done(function (response) {
                        if (response.status === 'success') {
                            if (response.error) {
                                alert(response.error);
                            } else {
                                const created = response['created'];
                                const redone = response['redone'];
                                alert(`Reports are scheduled to generate: new - ${created}, existing: ${redone}`);
                                $modal.modal('hide');
                                window.location.reload();
                            }
                        } else {
                            alert("Error has occurred.");
                        }
                    })
                    .fail(function () {
                        alert("Error has occurred.");
                    });
            });
        });

        //// Search by order - begin.
        const $merchantReportSearchOrderModal = $('.js--merchant-report--search-order--modal');

        $('.js--report-merchant--search-order--btn').on('click', function () {
            $merchantReportSearchOrderModal.find('input[name=orderId]').val('');
            $merchantReportSearchOrderModal.find('.js--error').addClass('d-none');
            $merchantReportSearchOrderModal.find('.js--merchant-report--search-order--modal--result').addClass('d-none');

            $merchantReportSearchOrderModal.attr('tabindex', null);
            $merchantReportSearchOrderModal.modal('show');
        });

        $merchantReportSearchOrderModal.find('form').on('submit', function (event) {
            event.preventDefault();

            const $error = $merchantReportSearchOrderModal.find('.js--error');
            $error.addClass('d-none');

            const $errorMessage = $merchantReportSearchOrderModal.find('.js--error--message');
            $merchantReportSearchOrderModal.find('.js--merchant-report--search-order--modal--result').addClass('d-none');

            const orderId = $merchantReportSearchOrderModal.find('input[name=orderId]').val();
            const regex1 = /^\d{5}-\d{5}-\d{5}$/;
            const regex2 = /^\d{15}$/;
            let errorMessage = null;
            if (!orderId) {
                errorMessage = 'Order Id is obligatory.';
            } else if (!regex1.test(orderId) && !regex2.test(orderId)) {
                errorMessage = 'The entered value is not a valid order Id.';
            }

            if (errorMessage) {
                $errorMessage.text(errorMessage);
                $error.removeClass('d-none');

                return;
            }

            $('#loader-overlay').addClass('show-loader');
            $.post('/reports/find-by-order', $merchantReportSearchOrderModal.find('form').serialize())
                .done(function (response) {
                    if (response.result) {

                        const $tableBody = $merchantReportSearchOrderModal
                            .find('.js--merchant-report--search-order--modal--result--table--body');
                        $tableBody.empty();

                        const reportIds = [];
                        for (let i in response.data) {
                            const $tr = $(`<tr>\
                                <td>${response.data[i]['merchant']}</td>\
                                <td>${response.data[i]['client']}</td>\
                                <td>${response.data[i]['createDate']}</td>\
                                <td>${response.data[i]['amount']}</td>\
                                <td>${response.data[i]['retSum']}</td>\
                                <td>${response.data[i]['count']}</td>\
                                <td>${response.data[i]['from']}</td>\
                                <td>${response.data[i]['to']}</td>\
                                <td>${response.data[i]['acquirer']}</td>\
                                <td>${response.data[i]['transactionTypes']}</td>\
                                <td>${response.data[i]['status']}</td>\
                            </tr>`);

                            $tableBody.append($tr);
                            reportIds.push(response.data[i]['id']);
                        }

                        $merchantReportSearchOrderModal.find('.js--merchant-report--search-order--modal--result').removeClass('d-none');
                        $merchantReportSearchOrderModal.find('.js--merchant-report--search-order--modal--result').data('reportIds', reportIds);
                    } else {
                        $errorMessage.text(response.message);
                        $error.removeClass('d-none');
                    }

                    $('#loader-overlay').removeClass('show-loader');
                })
                .fail(function () {
                    $errorMessage.text('Unexpected error.');
                    $error.removeClass('d-none');
                    $('#loader-overlay').removeClass('show-loader');
                });
        });

        $merchantReportSearchOrderModal.find('.js-apply').on('click', function (event) {
            event.preventDefault();

            const reportIds = $merchantReportSearchOrderModal
                .find('.js--merchant-report--search-order--modal--result')
                .data('reportIds');

            if (Array.isArray(reportIds) && reportIds.length > 0) {
                const params = new URLSearchParams();
                reportIds.forEach(id => params.append('reportIds[]', id));
                window.location.href = `/reports/report?${params.toString()}`;
            }
        });
        //// Search by order - end.
    }

    /// reports.create

    const $createMerchantReportForm = $('#create_merchant_report_form');
    if ($createMerchantReportForm.length > 0) {
        const $choiceYes = $('#report-is_monthly_yes-input'),
            $choiceNo = $('#report-is_monthly_no-input');
        const fnIsMonthlyChange = function () {
            const $monthlyRows = $('.monthly-row'),
                $dailyRows = $('.daily-row');
            if ($choiceYes.is(':checked')) {
                $monthlyRows.show();
                $dailyRows.hide();
            } else {
                $monthlyRows.hide();
                $dailyRows.show();
            }
        }

        $choiceYes.on('change', fnIsMonthlyChange).trigger('change');
        $choiceNo.on('change', fnIsMonthlyChange).trigger('change');
    }

    /// reports.create-pulled

    const $createPulledForm = $('#create_pulled_form');
    if ($createPulledForm.length > 0) {
        const fnUpdatePulledByDate = function () {
            const $self = $(this);
            if ($self.val()) {
                $.get('/reports/report/update-pulled-by-date', {
                    date: $self.val(),
                    merchantReportTypes: $('[data-id]').map(function () {
                        return {
                            merchantId: $(this).find('input.js-input-merchantId').val(),
                            sourceReportType: $(this).find('select.js-select-sourceTransactionType').val()
                        }
                    }).toArray()
                }).done(function (response) {
                    $('[data-id] input.js-input-lastOrderId').val('');
                    $('[data-id] span.js-text-lastReportDate').val('');
                    for (let i = 0; i < response.length; i++) {
                        if ('lastOrderId' in response[i]) {
                            response[i].lastOrderId = response[i].lastOrderId ?? '';
                            $(`[data-id="${response[i].id}"]`)
                                .find('input.js-input-lastOrderId')
                                .val(response[i].lastOrderId);
                        }
                        if ('lastReportDate' in response[i]) {
                            response[i].lastReportDate = response[i].lastReportDate ?? '';
                            $(`[data-id="${response[i].id}"]`)
                                .find('span.js-text-lastReportDate')
                                .text(response[i].lastReportDate);
                        }
                    }
                }).fail(function (response) {
                    console.log(response);
                });
            }
        }
        const fnUpdatePulledByTypes = function () {
            const $self = $(this),
                $row = $self.parents('[data-id]'),
                $dateInput = $('#date_from');
            if ($dateInput.val()) {
                $.get('/reports/report/update-pulled-by-date', {
                    date: $dateInput.val(),
                    merchantReportTypes: [{
                        merchantId: $row.find('input.js-input-merchantId').val(),
                        sourceReportType: $row.find('select.js-select-sourceTransactionType').val()
                    }]
                }).done(function (response) {
                    $row.find('input.js-input-lastOrderId').val('');
                    $row.find('span.js-text-lastReportDate').text('')
                    for (let i = 0; i < response.length; i++) {
                        if ('lastOrderId' in response[i]) {
                            $(`[data-id="${response[i].id}"]`)
                                .find('input.js-input-lastOrderId')
                                .val(response[i].lastOrderId);
                        }
                        if ('lastReportDate' in response[i]) {
                            $(`[data-id="${response[i].id}"]`)
                                .find('span.js-text-lastReportDate')
                                .text(response[i].lastReportDate);
                        }
                    }
                }).fail(function (response) {
                    console.log(response);
                });
            }
        }

        const fnShouldIssueAllClick = function () {
            const $self = $(this);
            $('input.js-checkbox-shouldIssue').prop('checked', $self.prop('checked'));
        }

        const fnShouldIssueCheckboxClick = function () {
            $('input.js-checkbox-shouldIssue-all')
                .prop('checked', $('input.js-checkbox-shouldIssue:not(:checked)').length === 0);
        }

        $('#date_from').on('change', fnUpdatePulledByDate);
        $('input.js-checkbox-shouldIssue-all')
            .on('click', fnShouldIssueAllClick);
        $('input.js-checkbox-shouldIssue')
            .on('click', fnShouldIssueCheckboxClick);
        $('select.js-select-sourceTransactionType').on('change', fnUpdatePulledByTypes);
        fnShouldIssueCheckboxClick();
    }

    /// reports.analytic.index

    const $reportsAnalyticTable = $('#table_report_analytic');
    if ($reportsAnalyticTable.length > 0) {
        const getTimeout = () => window.setTimeout(() => window.location.reload(), 30000);
        window.timeoutHandler = getTimeout();
        const $modal = $('.js-modal-report-analytic-details');
        const fnBtnShowDetailsClick = function (evt) {
            evt.preventDefault();
            const $btn = $(this);
            $.get($btn.data('url')).done(function (response) {
                if ('status' in response && response.status == 'success') {
                    for (let field in response.data) {
                        $modal.find('.js-details-' + field).text(response.data[field]);
                    }
                    $modal.modal('show');
                }
            });
        };

        const fnModalCloseCleanup = function (evt) {
            evt.preventDefault();
            $modal.find('.js-details').text('');
        };

        $reportsAnalyticTable.on('click', 'button.js-btn-show-details', fnBtnShowDetailsClick);
        $modal.on('hidden.bs.modal', fnModalCloseCleanup);
    }

    /// reports.analytic.create
    const $reportAnalyticCreateForm = $('#report-analytic-create-form');
    if ($reportAnalyticCreateForm.length) {
        $reportAnalyticCreateForm.find('input[type="checkbox"]')
            .on('change', function () {
                const $checkbox = $(this);
                const name = $checkbox.attr('name');
                const toggleElementsClass = `js--${name}--toggle`;

                $reportAnalyticCreateForm
                    .find(`.${toggleElementsClass}`)
                    .css('display', $checkbox.prop('checked') ? '' : 'none');

                const requiredElementsClass = `js--${name}--required`;
                const $elementsRequired = $reportAnalyticCreateForm.find(`.${requiredElementsClass}`);
                if ($elementsRequired.length) {
                    $elementsRequired.prop('required', $checkbox.prop('checked'));
                }
            })
            .trigger('change');
    }

    // Bass reports.
    const $bassReportsIndexPage = $('.js--bass-reports--index');
    if ($bassReportsIndexPage.length > 0) {
        const bassReportsGetSelectedReports = () => {
            const ids = {};

            $bassReportsIndexPage
                .find('input[type="checkbox"].js-checkbox-toggle-single[data-checkbox-toggle="bass_report"]')
                .filter(':checked')
                .each(function () {
                    const id = $(this).data('checkbox-toggle-value');

                    if (id) {
                        ids[id] = id;
                    }
                });

            return Object.keys(ids);
        }

        const bassReportExport = (ids) => {
            $.post('/reports/summary1c/bass-export', {
                ids: ids,
                isConfirm: true,
            })
                .done(function (response) {
                    alert(response.message);
                    if (response.status === 'success') {
                        location.reload();
                    }
                })
                .fail(function () {
                    alert('API error.');
                })
        }

        const bassReportDownload = (id) => {
            const href = '/reports/summary1c/download?id=' + id + '&splitByTransactionDate=' + 0,
                $link = $(`<a href="${href}" target="_blank"></a>`);
            $('body').append($link);
            $link[0].click();
            $link.remove();
        }

        const bassReportDownloadArchive = async (ids) => {
            const token = $('meta[name="csrf-token"]').attr('content');

            const response = await fetch('/reports/summary1c/download-archive', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': token
                },
                body: JSON.stringify({ids, split: 0})
            });

            const contentType = response.headers.get('Content-Type') || '';

            if (!response.ok || contentType.includes('application/json')) {
                let errMsg = 'Error has occurred during file downloading.';
                try {
                    const errJson = await response.json();
                    if (errJson.message) errMsg = errJson.message;
                } catch (e) {
                    // Silently ignored.
                }

                alert(errMsg);
                return;
            }

            const disposition = response.headers.get('Content-Disposition');
            if (!disposition) {
                alert('Error has been occurred.');

                throw new Error('Content-Disposition is absent.');
            }

            const filenameMatch = disposition.match(/filename\*=UTF-8''([^;]+)|filename=\"?([^\";]+)\"?/);
            if (!filenameMatch) {
                alert('Error has been occurred.');

                throw new Error('Receiving file name from `Content-Disposition` has been failed.');
            }
            const filename = decodeURIComponent(filenameMatch[1] || filenameMatch[2]);

            const blob = await response.blob();
            const urlFile = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = urlFile;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(urlFile);
        }

        $bassReportsIndexPage.on('change', 'select[name="actions"]', async function () {
            const $select = $(this);
            const action = +$select.val();

            if (!action) {
                return;
            }

            const reportIds = bassReportsGetSelectedReports();

            if (!reportIds.length) {
                $select.val(0).trigger('change');

                return;
            }

            console.log(reportIds);

            if (action === 1) {
                bassReportConfirmExportShow();
            } else if (action === 2) {

                if (reportIds.length > 1) {
                    await bassReportDownloadArchive(reportIds);
                } else if (reportIds.length === 1) {
                    bassReportDownload(reportIds[0])
                }
            }

            $select.val(0).trigger('change');
        });

        const $bassReportConfirmExport = $bassReportsIndexPage.find('.js--reports--summary1c--confirm--export');
        if ($bassReportConfirmExport.length === 1) {
            $bassReportConfirmExport.find('.js-confirm').on('click', function () {
                $bassReportConfirmExport.modal('hide');

                const reportIds = bassReportsGetSelectedReports();

                if (!reportIds.length) {
                    return;
                }

                bassReportExport(reportIds);
            });
            $bassReportConfirmExport.find('.js-decline').on('click', function () {
                $bassReportConfirmExport.modal('hide');
            });
        }

        const bassReportConfirmExportShow = function () {
            if ($bassReportConfirmExport.length !== 1) {
                return;
            }

            const reportIds = bassReportsGetSelectedReports();

            if (!reportIds.length) {
                return;
            }

            $bassReportConfirmExport.find('.js-number').html(reportIds.length);
            $bassReportConfirmExport.attr('tabindex', null);
            $bassReportConfirmExport.modal('show');
        }
    }

    /// service.liqpay

    const $serviceGetLiqpayForm = $('form#service_get_liqpay');
    if ($serviceGetLiqpayForm.length > 0) {
        const blockSwitch = function () {
            const $ieBlock = $('.js-liqpay-ie'),
                $cdBlock = $('.js-liqpay-cd'),
                type = parseInt($('select#type').val());
            switch (type) {
                case 1:
                case 2:
                case 3:
                case 5:
                    $ieBlock.css('display', '');
                    $cdBlock.css('display', 'none');
                    break;
                case 4:
                    $ieBlock.css('display', 'none');
                    $cdBlock.css('display', '');
                    break;
                default:
                    $ieBlock.css('display', 'none');
                    $cdBlock.css('display', 'none');
            }
        };

        $('select#type').on('change', blockSwitch).trigger('change');
    }

    // service.add-compensation-transaction
    const $serviceCompensationTransactionForm = $('form#service_correcting_transaction');
    if ($serviceCompensationTransactionForm.length > 0) {
        const $selectClientId = $('select#client_id');
        const $selectTerminalId = $('select#terminal_id');
        const $selectMerchantId = $('select#merchant_id');
        $selectMerchantId.on('change', function () {
            const $selectedBlock = $('.js-merchant-selected');
            $selectedBlock.css({display: 'none'});
            if ($(this).val() !== '') {
                if ($selectClientId.hasClass("select2-hidden-accessible")) {
                    $selectClientId.val(null).trigger('change');
                    $selectClientId.select2('destroy');
                    $selectClientId.html('');
                }
                if ($selectTerminalId.hasClass("select2-hidden-accessible")) {
                    $selectTerminalId.val(null).trigger('change');
                    $selectTerminalId.select2('destroy');
                    $selectTerminalId.html('');
                }
                $.get('/ajax/clients', {merchantId: $selectMerchantId.val()})
                    .done(function (response) {
                        $selectClientId.select2({
                            data: JSON.parse(response)
                        });
                        $selectClientId.val(response[0].id).trigger('change');
                        if ($selectTerminalId.hasClass("select2-hidden-accessible")) {
                            $selectedBlock.css({display: ''});
                        }
                    });
                $.get('/ajax/terminals', {merchantId: $selectMerchantId.val()})
                    .done(function (response) {
                        $selectTerminalId.select2({
                            data: JSON.parse(response)
                        });
                        $selectTerminalId.val(response[0].id).trigger('change');
                        if ($selectClientId.hasClass("select2-hidden-accessible")) {
                            $selectedBlock.css({display: ''});
                        }
                    });
            } else {
                $selectedBlock.css({display: 'none'});
            }
        }).trigger('change');

        const setRetSumVal = function () {
            const amount = $('input#amount').val().replace(',', '.') || 0.00,
                commission = $('input#commission').val().replace(',', '.') || 0.00,
                $retSumInput = $('input#retSum');

            $retSumInput.val(parseFloat(amount) - parseFloat(commission));
        }

        $('input#amount').on('change', setRetSumVal);
        $('input#commission').on('change', setRetSumVal);
    }

    // Operational.
    //// Mailing merchant reports.
    const $operationalMailingReportMerchantIndex = $('.js-operational-mailing-report-merchant-index');
    if ($operationalMailingReportMerchantIndex.length > 0) {
        $operationalMailingReportMerchantIndex
            .find('.js-operational-mailing-report-merchant-index-table .js-mail-resend-button')
            .on('click', function() {
                const $button = $(this);
                const mailId = $button.attr('data-mailId');

                if (!mailId) {
                    alert('Mail ID is not defined.')
                    return;
                }

                $.post('/operational/mailing/report-merchant/resend-one/' + mailId)
                    .done(function (response) {
                        alert(response.message);
                        if (response.status && response.status === true) {
                            location.reload();
                        }
                    })
                    .fail(function () {
                        alert("Error occurred.");
                    });
            });

        $operationalMailingReportMerchantIndex
            .find('.js-operational-mailing-report-merchant-index-form .js-pull-resend-button')
            .on('click', function() {
                const $form = $(this).closest('form');
                const formData = new FormData($form[0])

                const from = formData.get('createdAtFrom').toString(),
                    to = formData.get('createdAtTo').toString();

                if (!from || !to) {
                    alert('Select both dates.');
                    return;
                }

                const fromObject = new Date(from),
                    toObject = new Date(to);

                if (fromObject.getTime() > toObject.getTime()) {
                    alert('`From` should be less or equal to `To`');
                    return;
                }

                if ((toObject - fromObject) / 86_400_000 > 2) {
                    alert('Maximum date range is 3 days');
                    return;
                }

                $.post('/operational/mailing/report-merchant/resend-pull', $form.serialize())
                    .done(function (response) {
                        alert(response.message);
                        if (response.status && response.status === true) {
                            location.reload();
                        }
                    })
                    .fail(function () {
                        alert("Error occurred.");
                    });
            });
    }

    //// Mailing 1C reports.
    const $operationalMailingReport1CIndex = $('.js-operational-mailing-report-1c-index');
    if ($operationalMailingReport1CIndex.length > 0) {
        $operationalMailingReport1CIndex
            .find('.js-operational-mailing-report-1c-index-table .js-mail-resend-button')
            .on('click', function() {
                const $button = $(this);
                const mailId = $button.attr('data-mailId');

                if (!mailId) {
                    alert('Mail ID is not defined.')
                    return;
                }

                $.post('/operational/mailing/report-1c/resend-one/' + mailId)
                    .done(function (response) {
                        alert(response.message);
                        if (response.status && response.status === true) {
                            location.reload();
                        }
                    })
                    .fail(function () {
                        alert("Error occurred.");
                    });
            });

        $operationalMailingReport1CIndex
            .find('.js-operational-mailing-report-1c-index-form .js-pull-resend-button')
            .on('click', function() {
                const $form = $(this).closest('form');
                const formData = new FormData($form[0])

                const from = formData.get('createdAtFrom').toString(),
                    to = formData.get('createdAtTo').toString();

                if (!from || !to) {
                    alert('Select both dates.');
                    return;
                }

                const fromObject = new Date(from),
                    toObject = new Date(to);

                if (fromObject.getTime() > toObject.getTime()) {
                    alert('`From` should be less or equal to `To`');
                    return;
                }

                if ((toObject - fromObject) / 86_400_000 > 2) {
                    alert('Maximum date range is 3 days');
                    return;
                }

                $.post('/operational/mailing/report-1c/resend-pull', $form.serialize())
                    .done(function (response) {
                        alert(response.message);
                        if (response.status && response.status === true) {
                            location.reload();
                        }
                    })
                    .fail(function () {
                        alert("Error occurred.");
                    });
            });
    }

    $('div[data-role="form"]').each(function() {
        let $this = $(this);
        let formClass = $this.data('form');
        window[formClass].init($this);
    })

    // Safe Deal.
    /// Matching processes index.
    const $safeDealMatchingProcess = $('#safe-deal--matching--index-table');
    if ($safeDealMatchingProcess.length > 0) {
        const $safeDealMatchingRunModal = $('.js-safe-deal--matching--run-modal');

        $('.js-safe-deal--matching--run-button').on('click', function () {
            $safeDealMatchingRunModal.find('input[name="refreshDate"]').val('');
            $safeDealMatchingRunModal.find('input[name="isCreate"]').prop('checked', true);
            $safeDealMatchingRunModal.find('input[name="isReworkFailed"]').prop('checked', false);
            $safeDealMatchingRunModal.find('input[name="isReworkComplete"]').prop('checked', false);
            $safeDealMatchingRunModal.find('select').val(null).trigger('change');

            $safeDealMatchingRunModal.attr('tabindex', null);
            $safeDealMatchingRunModal.modal('show');
            $safeDealMatchingRunModal.find('.select2-search__field').css('width', '100%');
        });

        $safeDealMatchingRunModal.find('.js-confirm').on('click', function (event) {
            event.preventDefault();

            $.post('/sd-matching-process/run', $safeDealMatchingRunModal.find('form').serialize())
                .done(function (response) {
                    if (response.status === 'success') {
                        if (response.error) {
                            alert(response.error);
                        } else {
                            alert(response.message);
                            $safeDealMatchingRunModal.modal('hide');
                            window.location.reload();
                        }
                    } else {
                        alert("Error has occurred.");
                    }
                })
                .fail(function () {
                    alert("Error has occurred.");
                });
        });

        $safeDealMatchingRunModal.on('hide.bs.modal', function () {
            $safeDealMatchingRunModal.attr('tabindex', '-1');
        });

        $safeDealMatchingRunModal.find('select').each(function () {
            $(this).select2({
                placeholder: $(this).data('placeholder'),
                allowClear: Boolean($(this).data('allow-clear')),
                closeOnSelect: !$(this).attr('multiple'),
                width: 'style'
            });
        });
    }
    /// Merchant report index.
    const $safeDealMerchantReport = $('#safe-deal--merchant-report--index-table');
    if ($safeDealMerchantReport.length > 0) {
        const $safeDealMerchantReportCreateModal = $('.js-safe-deal--report--create-modal');

        $('.js-safe-deal--report--create-button').on('click', function () {
            $safeDealMerchantReportCreateModal.find('input[name="dateFrom"]').val('');
            $safeDealMerchantReportCreateModal.find('input[name="dateTo"]').val('');
            $safeDealMerchantReportCreateModal.find('select').val(null).trigger('change');

            $safeDealMerchantReportCreateModal.attr('tabindex', null);
            $safeDealMerchantReportCreateModal.modal('show');
            $safeDealMerchantReportCreateModal.find('.select2-search__field').css('width', '100%');
        });

        $safeDealMerchantReportCreateModal.find('.js-confirm').on('click', function (event) {
            event.preventDefault();

            const $form = $(this).closest('form');
            const formData = new FormData($form[0]);

            const merchantId = formData.get('merchantId');
            if (!merchantId) {
                alert('Select merchant.');
                return;
            }

            const from = formData.get('dateFrom').toString(),
                to = formData.get('dateTo').toString();

            if (!from || !to) {
                alert('Select both dates.');
                return;
            }

            const fromObject = new Date(from),
                toObject = new Date(to);

            if (fromObject.getTime() > toObject.getTime()) {
                alert('`Date From` should be less or equal to `Date To`');
                return;
            }

            $.post('/sd-reports/create', $safeDealMerchantReportCreateModal.find('form').serialize())
                .done(function (response) {
                    if (response.status === 'success' && response.message) {
                        alert(response.message);
                        $safeDealMerchantReportCreateModal.modal('hide');
                        window.location.reload();
                    } else {
                        alert("Error has occurred.");
                    }
                })
                .fail(function () {
                    alert("Error has occurred.");
                });
        });

        $safeDealMerchantReportCreateModal.on('hide.bs.modal', function () {
            $safeDealMerchantReportCreateModal.attr('tabindex', '-1');
        });

        $safeDealMerchantReportCreateModal.find('select').each(function () {
            $(this).select2({
                placeholder: $(this).data('placeholder'),
                allowClear: Boolean($(this).data('allow-clear')),
                closeOnSelect: !$(this).attr('multiple'),
                width: 'style'
            });
        });

        $('#js-safe-deal--report--error-modal')
            .on('show.bs.modal', function (event) {
                const button = $(event.relatedTarget);
                const errors = button.data('errors');

                for (let i in errors) {
                    const $errorDiv = $('<div/>');
                    $errorDiv.append(errors[i]);

                    $(this).find('.js-modal-body').append($errorDiv);
                }
            })
            .on('hide.bs.modal', function () {
                $(this).find('.js-modal-body').empty();
            })
    }

    // Export process.
    const $exportProcessSuccessNotificationModal = $('.js--export-process--success-notification-modal');
    if ($exportProcessSuccessNotificationModal.length === 1) {
        $exportProcessSuccessNotificationModal.find('.js-confirm').on('click', function (event) {
            $exportProcessSuccessNotificationModal.modal('hide');
        });
    }

    const exportProcess_successNotificationShow = function (message) {
        if ($exportProcessSuccessNotificationModal.length !== 1) {
            return;
        }

        $exportProcessSuccessNotificationModal.find('.js-message').html(message || 'The report has been created and added to the processing queue.');
        $exportProcessSuccessNotificationModal.attr('tabindex', null);
        $exportProcessSuccessNotificationModal.modal('show');
    }

    readyContainers.forEach(function(container) {
        container.attr('data-state-ready', 1);
    })

    document.dispatchEvent(new CustomEvent('jQuery:ready'));
});